// Menu caché "Réglages Dev" (double clic sur « 0cog » du pied de l'appli, sur le web seulement : voir game.js)
import { $, show, hide } from './dom.js';

export function createDevSettingsView() {
  const modal = $('devSettingsModal');
  const inputs = {
    size: $('devSize'),
    twist: $('devTwist'),
    speed: $('devSpeed'),
    bpm: $('devBpm'),
    startLevel: $('devStartLevel'),
    deadEnds: $('devDeadEnds'),
    playerSpeed: $('devPlayerSpeed'),
  };
  const lblStartLevel = $('lblStartLevel');

  inputs.startLevel.addEventListener('input', (e) => {
    lblStartLevel.innerText = e.target.value;
  });

  /** Remplit le formulaire avec les réglages courants et ouvre le modal */
  function open(settings) {
    inputs.size.value = settings.sizeStep;
    inputs.twist.value = Math.round(settings.twistiness * 100);
    inputs.speed.value = settings.speedFactor * 10;
    inputs.bpm.value = settings.musicBpm;
    inputs.startLevel.value = settings.startLevel;
    inputs.deadEnds.value = Math.round(settings.deadEnds * 100);
    inputs.playerSpeed.value = settings.playerSpeed;
    lblStartLevel.innerText = settings.startLevel;
    show(modal);
  }

  /** Lit le formulaire et retourne un nouvel objet de réglages */
  function read() {
    return {
      sizeStep: parseFloat(inputs.size.value),
      twistiness: parseInt(inputs.twist.value, 10) / 100,
      speedFactor: parseInt(inputs.speed.value, 10) / 10,
      musicBpm: parseInt(inputs.bpm.value, 10),
      startLevel: parseInt(inputs.startLevel.value, 10),
      deadEnds: parseInt(inputs.deadEnds.value, 10) / 100,
      playerSpeed: parseInt(inputs.playerSpeed.value, 10),
    };
  }

  return {
    open,
    read,
    close: () => hide(modal),
    btnClose: $('btnCloseDev'),
    btnSave: $('btnSaveDev'),
  };
}
